import { render, staticRenderFns } from "./profitTableComponent2.vue?vue&type=template&id=6660a6f8&scoped=true"
import script from "./profitTableComponent2.vue?vue&type=script&lang=js"
export * from "./profitTableComponent2.vue?vue&type=script&lang=js"
import style0 from "./profitTableComponent2.vue?vue&type=style&index=0&id=6660a6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6660a6f8",
  null
  
)

export default component.exports